export const emitEventGA = (name, params, targets) => {
    try {
        window.parent.postMessage({
            type: 'streamchat:event',
            payload: { name, params, targets }
        }, '*');
    } catch (e) {
        console.error(e)
    }
}
